import { z } from 'zod/v3';

export const fileSchema = z.object({
  fileUrl: z.string().url().describe('The URL to access the file.'),
  height: z
    .number()
    .optional()
    .describe('The height of the file in pixels, if applicable.'),
  mimeType: z.string().describe('The MIME type of the file.'),
  originalName: z.string().describe('The original name of the file.'),
  size: z.number().describe('The size of the file in bytes.'),
  uniqueName: z.string().describe('The name of the file.'),
  width: z
    .number()
    .optional()
    .describe('The width of the file in pixels, if applicable.'),
});

export type FileSchema = z.infer<typeof fileSchema>;
